export default __webpack_public_path__ + "static/image1-8293cd991e6dcda695447bd8beb2bfff.png";